import { AppData, Lightning, Log } from '@lightningjs/sdk'
import { Artwork, Badge, Base, ButtonSmall, FocusManager, Icon, NavigationManager, Row } from '@lightningjs/ui-components'
import { ItemNode } from '../lib/components/grid/ItemNode'
import { Helper } from '../lib/helper';
import { AppSetup } from '../lib/app-setup';
import StarUI from './star-ui';
import GridViewModel, { FocusInfo } from '../lib/components/grid/grid-view-model';
import RowList from '../lib/components/grid/row-model';
import TopCarouselMarker from './top-carousel-marker';
import { Logger } from '../lib/logger';

export interface Theme {
    ageRatingColor: string;
    titleColor: string;
    textSize: number;
    textcolor: string;
    gridfocuscolor: string;
    bgcolor: string;
}

export default class TopCarouselUi extends Base<Base.TemplateSpec> {
    NodeImg: any = this.getByRef('NodeImg')!
    PreLoadBanner: any = this.getByRef('PreLoadBanner')!
    ImageWrapper: any = this.getByRef('ImageWrapper')!
    ButtonsWrapper: any = this.getByRef('ButtonsWrapper')!
    Carousel: any = (this as any).getByRef('Carousel')!
    _theme: Theme = {
        ageRatingColor: '',
        titleColor: '',
        textSize: 0,
        textcolor: '',
        gridfocuscolor: '',
        bgcolor: ''
    };
    prefetchImageArry: [] = []
    rowItem!: RowList
    uiList: any[] = [];
    grid!: GridViewModel
    focusInfo!: FocusInfo
    isLoaded = false
    isResolvingItem = false;
    _initialLoadComplete = false
    _scrollTimer: number | null = null
    _debounceTimer: number | null = null
    _animationTimer: number | null = null
    _preloadTimer: number | null = null
    prevTime = 0;
    static readonly SCROLL_DELAY = 8000;
    static readonly FADE_DURATION = 0.25;
    static readonly DEBOUNCE_DELAY = 300;
    static readonly PRELOAD_WINDOW = 3;
    static readonly THROTTLE_DELAY = 250;
    static readonly MAX_ITEMS = 10;

    static override _template() {
        return {
            PreLoadBanner: {
                alpha: 0.001,
                childrens: []
            },
            NodeImg: {
                w: 1920,
                h: 1080,
                x: 1920,
                y: 0,
                src: '',
                alpha: 0.001,
                mountX: 1,
            },
            ImageWrapper: {
                w: (w) => w,
                h: (h) => h,
                texture: '',
            },
            InfoTextWrapper: {
                x: 172,
                y: 202,
                alpha: 1,
                flex: { direction: 'column' },
                Title: {
                    text: {
                        text: '',
                        fontFace: Helper.getFontFamily('Black'),
                        fontSize: 42,
                        wordWrapWidth: 900,
                        maxLines: 2,
                        maxLinesSuffix: '...',
                        textOverflow: 'ellipsis'
                    },
                    color: ''
                },
                ItemMetadataWrapper: {
                    flex: { direction: 'row', wrap: false },
                    rect: true,
                    color: 0x00000000,
                    children: []
                },
                Description: {
                    y: 20,
                    text: {
                        text: '',
                        fontSize: 30,
                        fontFace: Helper.getFontFamily('Regular'),
                        wordWrapWidth: 700,
                        maxLines: 3,
                        maxLinesSuffix: '...MORE',
                        textOverflow: 'ellipsis',
                        lineHeight: 40,
                        letterSpacing: 0.5
                    }
                },
            },
            ButtonsWrapper: {
                x: 172,
                y: 475,
                flex: { direction: 'row', wrap: false },
                PlayButton: {
                    type: ButtonSmall,
                    title: '▶ Play',
                    w: 200,
                    h: 60,
                },
            },
            Carousel: {
                x: 960,
                y: 660,
                mountX: 0.5,
                type:Row,
                autoResizeWidth: true,
                neverScroll: true,
                h: 80,
                items: []
            }
        }
    }

    override _init() {
        super._init()
        const { appState } = AppData as AppSetup;
        const app = appState?.getApp();
        this._theme = (app?.themesObj as Theme) || {};
        const appApiConfig = appState?.getAppApiConfig()!
        this._theme.titleColor = `0xff${appApiConfig?.appConfig?.titleColor}` || '0xffffffff'
        this._theme.ageRatingColor = `0xff${appApiConfig?.appConfig?.ageRatingColor}` || '0xffffffff'

        this.tag('NodeImg').on('txLoaded',()=>{
            console.log('Top Carousel - loaded ')
            this.tag('Carousel').selected._progressAnim.start()
        })
    }

    static get __componentName() {
        return 'TopCarousel';
    }

    static get tags() {
        return ['PreLoadBanner', 'NodeImg', 'ImageWrapper', 'InfoTextWrapper', 'ButtonsWrapper', 'Carousel']
    }

    static get properties() {
        return ['grid']
    }

    _update() {
        if (!this.grid) {
            //show a loading or a Facade image
        } else {
            this.grid.on('loaded', this._gridLoadedHandler, this)
            this.grid.on('focused', this._gridFocusedHandler, this)
            this.grid.on('selected', this._gridSelectedHandler, this)
            this.grid._init()
        }
    }

    _gridLoadedHandler(event: any) {
        this.grid.createGridListUI()
        const row:RowList = this.grid.getRowAt(0) as RowList
        if(row.videosCount > TopCarouselUi.MAX_ITEMS) {
            row.setPageData(TopCarouselUi.MAX_ITEMS,20,row.videos.slice(0,TopCarouselUi.MAX_ITEMS))
        }
        
        this._initialLoadComplete = true // Mark initial load as complete

        this._preloadFutureImages(0).then(()=>{
            this._createCarouselItems()
        })
        //this._createCarouselItems()
        // this.focusInfo = this.grid.getFocusInfo()
        // this.selectedIndex = 0
        // this._updateInfoImmediate()
        
        // this._startScrollTimer();
    }

    _preloadFutureImages(currentIndex: number):Promise {
        
        return new Promise((resolve)=>{
            const promises = [];
            const row:RowList = this.grid.getRowAt(0)
            let startIndex = currentIndex== 0 ? 0 : currentIndex -1
            let endIndex = currentIndex >= row.videos.length-1 ? 0 : currentIndex+1
            for (let i = startIndex; i <= endIndex; i++) {
                if(!this.prefetchImageArry[i]) {
                    const item:ItemNode = row.videos[i]
                    const img = new Image(1920,1080)
                    promises.push(new Promise((resolve)=>img.onload = ()=>resolve(true)))
                    img.src = item.hero_image || item.bg_image_landscape;
                    this.prefetchImageArry[i] = img
                }
            }
            Promise.all(promises).then((items) => {
                console.log('TopCarousel - ', this.prefetchImageArry)
                resolve(true)        
            });
        })
        
    }

    _gridFocusedHandler(event: any) {
        
        if (!this._initialLoadComplete) {
            return
        }

        this.focusInfo = this.grid.getFocusInfo()
        console.log('TopCarousel - _gridFocusedHandler', this.focusInfo)
        this._updateInfoWithAnimation()
        setTimeout(()=>{
            this._preloadFutureImages(this.focusInfo.foucsItem+1)
        },100)
        
    }

    async _gridSelectedHandler(event: any) {
        if (this.isResolvingItem) return;

        this.isResolvingItem = true;
        this.fireAncestors('$showLoadingScreen', true);
        try {
            const vodInfo: ItemNode = this.grid.getFocusedItem()
            const resolvedItem = await this._resolvePlayableItem(vodInfo);
            this.fireAncestors('$handleCorouselSelectedItem', resolvedItem);
        } catch (e) {
            Log.error('TopCarousel: Error resolving playable item', e);
        } finally {
            this.isResolvingItem = false;
            this.fireAncestors('$showLoadingScreen', false);
        }
    }

    $prev() {
        let index = this.tag('Carousel').selectedIndex
        if(index <= 0 ) {
            index = this.tag('Carousel').items.length -1
        } else {
            index--
        }
        this.tag('Carousel').selectedIndex = index

    }

    $next() {
        let index = this.tag('Carousel').selectedIndex
        if(index >= this.tag('Carousel').items.length -1 ) {
            index = 0
        } else {
            index++
        }
        this.tag('Carousel').selectedIndex = index

    }

    $focusedItem(index) {
        const focusInfo = this.grid.getFocusInfo()
        focusInfo.foucsItem = index
        this.grid.changeFocus(focusInfo)
        Logger.processUserAction('CarouselImpression');
    }

    canHandleKey() {
        const newTime = new Date().getTime()
        const delta =  newTime - this.prevTime

        if(delta > 300) {
            this.prevTime = newTime
            return true
        }
        return false
    }

    override _handleRight() {
        this.$next()
        return true
    }

    override _handleEnter(): boolean | void {
        this.grid._dispatchEvent('selected')
        return true
    }

    override _captureRight(e: KeyboardEvent): boolean | void {
        if(this.canHandleKey()) {
            return false
        }
        return true
    }

    override _captureLeft(e: KeyboardEvent): boolean | void {
        if(this.canHandleKey()) {
            return false
        }
        return true
    }

    /** 
    * @method _resolvePlayableItem
    * @description Recursively resolve the playable item from a container (e.g. ListOfList/Series)
    * This enables "Direct Play" from the Top Carousel, skipping the MLP page.
    */
    async _resolvePlayableItem(item: ItemNode, depth = 0): Promise<ItemNode> {
        if (depth > 5) return item;

        if (item.type === 'listoflist' || item.type === 'new-qid' || item.feed_type === 'banner') {
            const { appState } = AppData as AppSetup;
            const app = appState?.getApp();

            try {
                const mlpGrid: GridViewModel = (app?.loadShowPrefetch(item, item.id))!
                
                if (mlpGrid) {
                    await mlpGrid._init();
                    mlpGrid.createGridListUI();
                    
                    if (app?.navigation) {
                        if (!app.navigation.continuesStack.includes(mlpGrid)) {
                            app.navigation.push(mlpGrid);
                        }
                    }
                    
                    const focusedItem = mlpGrid.getFocusedItem();
                    const resolved = await this._resolvePlayableItem(focusedItem, depth + 1);
                    return resolved;
                }
            } catch (e) {
                Log.error('TopCarousel: Failed to resolve playable item', e);
                return item;
            }
        }

        return item;
    }

    $selectedChange(next: any, prev: any) {
        // Not using manual signal, replaced by logic in setters/layout
    }

    _createCarouselItems() {
        
        const gridViewModel = this.grid;
        const rowItem = gridViewModel.getRowAt(0)!
        this.rowItem = rowItem
        const items: any = [];
        const { appState } = AppData as AppSetup
        const appApiConfig = appState?.getAppApiConfig()
        const focusColor = Helper.getHexaColor(appApiConfig?.appLayoutConfig.textfocuscolor)
        // const { appState } = AppData as AppSetup;
        
        rowItem.videos.map((item: ItemNode, index) => {
            items.push({
                type: TopCarouselMarker,
                w: 20, 
                h: 20,
                progcolor:focusColor,
                centerInParent:true,
                index: index
            });
        });
        
        // Calculate total width to center properly
        // const count = items.length;
        // const spacing = 15;
        // // 1 active (60) + (N-1) inactive (20)
        // const totalWidth = 60 + (count - 1) * 20 + (count - 1) * spacing;
        
        // const { appState } = AppData as AppSetup;
        // const appApiConfig = appState?.getAppApiConfig()
        // const focusColor = Helper.getHexaColor(appApiConfig?.appLayoutConfig.textfocuscolor)

        this.patch({
            Carousel: {
                duration:TopCarouselUi.SCROLL_DELAY/1000,
                color: focusColor,
                items: items
            }
        });

        this._updateButtonFocus()
    } 
    

    private _updateButtonFocus(): void {
        const { appState } = AppData as AppSetup;
        const appApiConfig = appState?.getAppApiConfig()
        const focusColor = Helper.getHexaColor(appApiConfig?.appLayoutConfig.textfocuscolor)

        this.patch({
            ButtonsWrapper: {
                PlayButton: {
                    style: {
                        backgroundColor: focusColor,
                        textStyle: {
                            textColor: 0xffffffff,
                            fontSize: 24,
                            fontFace: Helper.getFontFamily('regular')
                        },
                    },
                }
            }
        })
    }

    set background(url: string) {
        this.patch({
            ImageWrapper: {
                texture: {
                    src: url,
                    resizeMode: {
                        h: 1080,
                        w: 1920,
                        type: 'contain',
                    },
                    type: Lightning.textures.ImageTexture
                },
            },
        })
    }

    getPatchObjects(item: ItemNode): any {
        const infoObj: any = {
            Title: { text: item.title, color: this._theme.titleColor },
            ItemMetadataWrapper: {
                children: []
            },
            Description: {
                text: { text: item.description },
            },
        }
        const runtimeAlpha = (item.runtime == 0 ? 0 : 1)
        const ageRatingAlpha = (item.age_appropriate_rating == '' ? 0 : 1)
        const popularityRatingAlpha = (item.popularity_rating == -1 ? 0 : 1)
        const releaseDate = item.release_date
        if (releaseDate !== '') {
            infoObj.ItemMetadataWrapper.children.push({
                h: 40,
                flexItem: { marginLeft: 0, marginRight: 40 },
                text: { alpha: 0.5, text: releaseDate, fontSize: 28, fontFace: Helper.getFontFamily('Light') },
            })
        }
        if (runtimeAlpha == 1) {
            infoObj.ItemMetadataWrapper.children.push({
                h: 40,
                flexItem: { marginLeft: 0, marginRight: 40 },
                text: { alpha: 0.5, text: Helper.secondsToHms(item.runtime), fontSize: 28, fontFace: Helper.getFontFamily('Light') },
            })
        }
        if (ageRatingAlpha == 1) {
            infoObj.ItemMetadataWrapper.children.push({
                h: 40,
                flexItem: { marginLeft: 0, marginRight: 40 },
                type: Badge,
                title: item.age_appropriate_rating,
                style: {
                    offsetY: 2,
                    paddingX: 20,
                    backgroundColor: 0xffffffff,
                    textStyle: {
                        fontSize: 22,
                        fontFace: Helper.getFontFamily('Black'),
                        textColor: this._theme.ageRatingColor
                    }
                }
            })
        }
        if (popularityRatingAlpha == 1) {
            infoObj.ItemMetadataWrapper.children.push({
                h: 40,
                alpha: popularityRatingAlpha,
                type: StarUI,
                rating: item.popularity_rating,
            })
        }
        return infoObj
    }

    private _updateInfoWithAnimation(): void {
            const currentVodInfo = this.grid.getFocusedItem()
            const currentSrc = currentVodInfo.hero_image == '' ? currentVodInfo.bg_image_landscape : currentVodInfo.hero_image
            const infoTextPatch = this.getPatchObjects(currentVodInfo);
            const infoText = (this as any).tag('InfoTextWrapper');
            if (infoText) {
                infoText.patch(infoTextPatch);
            }
            
            console.log('TopCarousel - ', currentSrc)
            setTimeout(()=>{
                this.patch({
                    NodeImg: {
                        src: currentSrc,
                        alpha:0.5
                    },
                    
                })
            },100)
            
            //this._setElementsAlpha(1, FADE_DURATION, 'ease-out');
            //this._schedulePreload(this.focusInfo.foucsItem)
            //this._animationTimer = null;
       // }, FADE_DURATION * 1000)
    }

    private _setElementsAlpha(alpha: number, duration: number, timingFunction: string) {
        const transition = { duration, timingFunction };
        const patch = { smooth: { alpha: [alpha, transition] } };
        const infoText = (this as any).tag('InfoTextWrapper');
        if (infoText) {
            infoText.patch(patch);
        }
        if (this.NodeImg) {
            this.NodeImg.patch(patch);
        }
    }

    override _getFocused(): Lightning.Component | null | undefined {
        return this.tag('Carousel')!
    }

    override _focus(): void{
        
    }

    override _unfocus() {
    }

    override _handleBack(e: KeyboardEvent): boolean | void {
        this.fireAncestors('$openL1')
    }

    override _detach() {
        this.stage.gc(false)
        this.prefetchImageArry = []
        if (!this.grid) return
        this.grid.off('loaded', this._gridLoadedHandler, this)
        this.grid.off('focused', this._gridFocusedHandler, this)
        this.grid.off('selected', this._gridSelectedHandler, this)
    }
}
